// import { useAuth } from 'Components/Hooks/AuthHooks';
import OldLogin from 'pages/Authentication/OldLogin';
import { Navigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useAuth } from 'Components/Hooks/AuthHooks';

// const AuthProtected = ({ children }: { children: any }) => {
//   const { authenticated, authChecked } = useAuth();

//   if (!authChecked) return null;

//   return authenticated ? (
//     children
//   ) : process.env.NODE_ENV === 'development' ? (
//     <Navigate to="/login" />
//   ) : (
//     <OldLogin />
//   );
// };

// export default AuthProtected;

// const AuthProtected = ({ children }: { children: any }) => {
//   const { authenticated, authChecked } = useAuth();
//   const location = useLocation();

//   if (!authChecked) return null;

//   if (!authenticated) {
//     sessionStorage.setItem('redirect', location.pathname);

//     return process.env.NODE_ENV === 'development' ? (
//       <Navigate to="/login" replace />
//     ) : (
//       <OldLogin />
//     );
//   }

//   return children;
// };

// export default AuthProtected;

// const AuthProtected = ({
//   children,
//   authenticated,
// }: {
//   children: any;
//   authenticated: boolean;
// }) => {
//   const location = useLocation();
//   if (!authenticated) {
//     sessionStorage.setItem('redirect', location.pathname);
//     return process.env.NODE_ENV === 'development' ? (
//       <Navigate to="/login" replace />
//     ) : (
//       <OldLogin />
//     );
//   }

//   return children;
// };

// export default AuthProtected;

// const AuthProtected = ({ children }: any) => {
//   const { authenticated } = useSelector((state: RootState) => state.Login);
//   const location = useLocation();

//   if (!authenticated) {
//     sessionStorage.setItem('redirect', location.pathname);
//     return process.env.NODE_ENV === 'development' ? (
//       <Navigate to="/login" replace />
//     ) : (
//       <OldLogin />
//     );
//   }

//   return children;
// };

// export default AuthProtected;

const AuthProtected = ({ children }: any) => {
  const { authenticated, authChecked } = useAuth();
  const location = useLocation();

  if (!authChecked) return null; // prevent flash

  if (!authenticated) {
    sessionStorage.setItem('redirect', location.pathname);

    return process.env.NODE_ENV === 'development' ? (
      <Navigate to="/login" replace />
    ) : (
      <OldLogin />
    );
  }

  return children;
};

export default AuthProtected;
